module.exports = __webpack_public_path__ + "img/wish-reveal-background.247b7aef.webp";